import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { supabase } from "../../client";
import LargeContainer from "../LargeContainer";
import MainContainer from "../MainContainer";
import ProductCard from "../ProductCard";

const NewProductSection = ({ addToCart, cart }) => {
  const [product, setProduct] = useState([]);

  const getProduct = async (e) => {
    const products = (await supabase.from("products").select().limit(4)).data;
    setProduct(products);
  };

  useEffect(() => {
    getProduct();
  }, []);
  return (
    <LargeContainer
      style={{ flexDirection: "column", marginTop: "6em" }}
      valign="center"
    >
      <MainContainer
        style={{ flexDirection: "column", textAlign: "center" }}
        valign="center"
      >
        <SectionHeading>NEW PRODUCTS</SectionHeading>
        <>
          Contrary to popular belief, Lorem Ipsum is not simply random text.{" "}
          <br />
          It has roots in a piece of classical Latin literature
        </>
      </MainContainer>

      <MainContainer style={{ marginTop: "2em" }}>
        {product.map((p) => (
          <ProductCard
            key={p.id}
            product={p}
            addToCart={addToCart}
            cart={cart}
            width="25%"
          />
        ))}
      </MainContainer>
    </LargeContainer>
  );
};
const SectionHeading = styled.div`
  font-size: 2em;
  font-weight: 700;
  color: #393939;
  display: flex;
  align-items: center;
  padding: 1rem;
  ::before,
  ::after {
    margin: 0 1rem;
    content: " ";
    width: 72px;
    height: 2px;
    background-color: #83aa4c;
  }
`;
export default NewProductSection;
